import { Telescope } from "@untitled-ui/icons-react";
import { type TFunction } from "i18next";

import { type Tenant } from "@/types";

export default {
  name: "performance",
  priority: 4,
  icon: Telescope,
  menu: ({ t }: { t: TFunction; tenant: Tenant }) => ({
    admin: [
      {
        label: t("Performance Mgmt", { ns: "performance.shared" }),
        icon: <Telescope />,
        child: [
          {
            label: t("Objective-Setting Courses", { ns: "performance.admin" }),
            to: "/admin/performance/objectives/periods",
            permission: "performance.performance-objective-period.view",
          },
          {
            label: t("Performance Evaluation Courses", {
              ns: "performance.admin",
            }),
            to: "/admin/performance/reviews/periods",
            permission: "performance.performance-review-period.view",
          },
          {
            label: t("Manage Tags", { ns: "performance.admin" }),
            to: "/admin/performance/tags",
            permission: "performance.performance-tag.view",
          },
        ],
      },
    ],
    settings: [
      {
        label: t("Performance Mgmt", { ns: "performance.shared" }),
        icon: <Telescope />,
        to: "/admin/settings/performance",
        permission: "performance.performance-settings.view",
      },
    ],
  }),
} satisfies ModuleData;
